<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="text-h6">
        Confirm Medications
      </v-card-title>

      <v-card-text>
        <p class="mb-3">You are about to administer the following medications:</p>
        <v-list dense>
          <v-list-item 
            v-for="(med, index) in selectedMedications" 
            :key="index"
            class="px-0"
          >
            <v-list-item-avatar size="24">
              <v-icon small color="primary">mdi-pill</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-body-2" v-html="med.Medication"></v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                Time: {{ med.newAdminTime }} | Qty: {{ med.Quantity }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="my-3"></v-divider>
        <p class="text-body-2 font-weight-medium">Do you want to proceed with administering these medications?</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey darken-1" text @click="close">
          Cancel
        </v-btn>

        <v-btn color="primary" text @click="onSubmit">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    selectedMedications: {
      type: Array,
      default: () => [],
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSubmit() {
      this.$emit("confirmed");
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>